import { push } from 'react-router-redux';

export const RECEIVE_ARCHIVED_WAVES = '@@waveArchive/RECEIVE_ARCHIVED_WAVES';
export const FETCHING_ARCHIVED_WAVES = '@@waveArchive/FETCHING_ARCHIVED_WAVES';

const emptyArray = [];

const initialState = {
  archivedWaves: emptyArray,
  isFetching: false,
};

// reducer

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_ARCHIVED_WAVES: {
      const { isFetching } = action;
      return {
        ...state,
        isFetching,
      };
    }
    case RECEIVE_ARCHIVED_WAVES:
      return {
        ...state,
        archivedWaves: action.archivedWaves,
      };

    default:
      return state;
  }
}

// action creators

export function receiveArchivedWaves(archivedWaves) {
  return {
    type: RECEIVE_ARCHIVED_WAVES,
    archivedWaves,
  };
}

function fetchingArchivedWaves(isFetching) {
  return {
    type: FETCHING_ARCHIVED_WAVES,
    isFetching,
  };
}
// thunks

export function fetchArchivedWaves(baseUrl = '') {
  return (dispatch, getState) => {
    dispatch(fetchingArchivedWaves(true));
    return fetch(`${baseUrl}/api/wavearchive`, {
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return response;
      })
      .then(responseJson => {
        if (responseJson.status && responseJson.status !== 200) {
          console.log('Error');
          return dispatch(push('/login'));
        }
        const { archivedWaves } = responseJson;
        return dispatch(receiveArchivedWaves(archivedWaves));
      })
      .then(always, always);

    function always() {
      dispatch(fetchingArchivedWaves(false));
    }
  };
}

export function clickArchive(target) {
  return {
    type: '', // no actual actions
    meta: {
      analytics: {
        type: 'event-archive-click',
        payload: {
          target,
        },
      },
    },
  };
}
